export const socialsData = {
    github: 'https://github.com/ramki45',
   
    linkedIn: 'https://www.linkedin.com/in/ramki-marichamy-2a2156232/'
   
   
   }